<template>
  <div>
    <p class="small text-muted align-items-center">
      {{ childName }} has earned
      {{ starsEarned }}
      <b-img
        fluid
        :src="require(`@/assets/star.png`)"
        class="icon-star-small h-auto align-self-center"
      >
      </b-img>
      out of {{ starsToWin }}
      <b-img
        fluid
        :src="require(`@/assets/star.png`)"
        class="icon-star-small h-auto align-self-center"
      />
      today
    </p>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    starsEarned: {
      type: Number,
      default: 0,
    },
    starsToWin: {
      type: Number,
      default: 0,
    },
    currentChild: {
      type: [String, Number],
      default: '',
    },
  },
  computed: {
    ...mapGetters('parent', ['getListChildrenSelectFormat']),
    childName() {
      const child = this.getListChildrenSelectFormat.find(
        (child) => Number(child.value) === Number(this.currentChild),
      );
      return child['text'] || '';
    },
  },
};
</script>
